module.exports = __webpack_public_path__ + "img/001_zh.2beb1db.png";